// Written in this round about way for babel-transform-imports
import Prompt from 'react-router/es/Prompt';

export default Prompt;


//////////////////
// WEBPACK FOOTER
// ./node_modules/.4.2.2@react-router-dom/es/Prompt.js
// module id = 502
// module chunks = 1